import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import { toast, ToastContainer } from "react-toastify";
import useButtonLoader from "../hooks/useButtonLoader";
import { Url } from "../config/config";
import axios from "axios";

export default function Login() {
  const history = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setError] = useState({ email: "", password: "" });
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Log In",
    "Please wait..."
  );
  //************Handel Login Form Validation********************** */
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!email) {
      formIsValid = false;
      errors["email"] = "Please enter Email Id";
    }
    if (!password) {
      formIsValid = false;
      errors["password"] = "Please enter Password";
    }
    setError(errors);
    return formIsValid;
  };

  //*************Handel User Login ************************/
  const userLogin = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      const res = await axios({
        url: `${Url}/login`,
        method: "POST",
        data: {
          email,
          password,
        },
      });
      setSubmitLoading(false);
      if (res.data.status == 200) {
        console.log(res.data.token);
        localStorage.setItem(
          "login",
          JSON.stringify({
            token: res.data.data.user.accessToken,
            name: res.data.data.user.name,
            // profile:res.data.data.user.accessToken
          })
        );
        history("/dashboard");
      } else {
        toast.error(res.data.message);
      }
    }
    //
  };
  return (
    <React.Fragment>
      <title>Volt | Login</title>
      <div className="LoginArea">
        <form method="POST">
          <div className="LoginBox">
            <figure>
              <img src={Logo} />
            </figure>
            {/* <h5>Let's Get Started Corner Distribution</h5> */}
            <h6>
              To keep connected with us please login<br></br> wit your personal
              info.
            </h6>

            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Email Id"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="Icon">
                <i className="fa fa-user"></i>
              </span>
              <span style={{ color: "red" }} className="error">
                {errors.email}
              </span>
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter Password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="Icon">
                <i className="fa fa-unlock-alt"></i>
              </span>
              <span style={{ color: "red" }} className="error">
                {errors.password}
              </span>
            </div>
            <button onClick={userLogin} ref={submitButtonElement}>
              Log In <i className="fa fa-sign-in"></i>
            </button>
            <br></br>
            <Link to="/forgot-password">Forgot Password</Link>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}
